import { UserNode } from './../user-node';

export class UserNodeBuilder {
    static build(siteId, teamId, userNodeVO, periods?: Array<{start: string, end:string}>): UserNode {
        const userNode = new UserNode();
        userNode.id = userNodeVO.id;
        userNode.periods = (typeof userNodeVO.periods == 'undefined' ? periods : userNodeVO.periods);
        userNode.site = siteId;
        userNode.team = teamId;
        userNode.firstName = userNodeVO.firstName;
        userNode.lastName = userNodeVO.lastName;
        userNode.username = userNodeVO.username;
        userNode.assignement = userNodeVO.assignement;
        return userNode;
    }
}



// WEBPACK FOOTER //
// ./src/app/model/builder/user-node.builder.ts